PJQ.inputs.SelectpickerProjectMessageSendOptions = PJQ.inputs.Selectpicker.extend({
	onChange: function (event, clickedIndex) {
		this.lastValue = this.getValue();

		if (_.size(this.lastValue) === 0) {
			this.setValue(["1"]);
		} else if (this.options.isMultiple && _.size(this.options.exclusiveChoices) > 0) {
			let exclusiveChoices = [],
				choice = $(this.$el.find('option')[clickedIndex]).attr('value');
			if (PJQ.helpers.objectHelpers.refinedType(this.options.exclusiveChoices) === 'array')
				exclusiveChoices = this.options.exclusiveChoices;
			else
				exclusiveChoices.push(this.options.exclusiveChoices);

			this.lastValue = (_.indexOf(exclusiveChoices, choice) !== -1) ? ["1", choice] : _.union(["1"], _.filter(this.lastValue, function (item) {
				return _.indexOf(exclusiveChoices, item) === -1;
			}));

			this.setValue(this.lastValue);
		}
		if (this.options.isMirrorOptionColors && !this.options.isMultiple) {
			this.setInputColors();
		}

		this.options.onChange(this.lastValue);
	}
});